module.exports = __webpack_public_path__ + "img/secretary-appointment.41f6ea25.svg";